import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './FeatureL2.css';

function FeatureL2() {
  const navigate = useNavigate();
  
  const features = [
    {
      icon: 'las la-search',
      background: "var(--feature-color-1)",
      title: "Plan And Research",
      description: "We'll collaborate with you to shape and research your ideas, ensuring a well-informed and strategic planning process.",
      delay: 0.2,
      path: "/Consulting"
    },
    {
      icon: 'las la-code',
      background: "var(--feature-color-2)",
      title: "Development",
      description: "We specialize in transforming your ideas into reality using cutting-edge technologies.",
      delay: 0.3,
      path: "/Development"
    },
    {
      icon: 'las la-cogs',
      background: "var(--feature-color-3)",
      title: "Operations",
      description: "We oversee both the operational intricacies and scalable growth of your idea, ensuring a seamless and high-performance journey.",
      delay: 0.4,
      path: "/Operations"
    },
    {
      icon: 'las la-plug',
      background: "var(--feature-color-4)",
      title: "Integrations",
      description: "We bring synergy to your operations by seamlessly integrating diverse systems, creating a cohesive and efficient workflow for your business.",
      delay: 0.5,
      path: "/Operations"
    },
    {
      icon: 'las la-shield-alt',
      background: "var(--feature-color-5)",
      title: "Security",
      description: "With security at the forefront of our approach, we design every aspect with vigilant consideration, embedding protective measures into the very fabric of your digital environment.",
      delay: 0.6,
      path: "/Security"
    },
    {
      icon: 'las la-headset',
      background: "var(--feature-color-6)",
      title: "Consulting and Support",
      description: "We serve as your dependable support and consulting partner, offering expertise and assistance whenever you require guidance or strategic insights.",
      delay: 0.7,
      path: "/Consulting"
    }
  ];

  return (
    <section className="feature-section">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <motion.div
              className="section-header"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
            >
              <span className="section-tag">Streamlined Development</span>
              <h2 className="section-title">
                End-to-End Solutions
                <span className="gradient-text">DevOps Excellence</span>
              </h2>
              <p className="section-description">
Successful software depends on more than code—it requires strong architecture, security, infrastructure, testing, monitoring, and long-term operations. epicfinal is here to accelerate your business growth with end-to-end software engineering services.              </p>
            </motion.div>
          </Col>
        </Row>

        <motion.div
          className="genai-english-promo"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <div className="genai-english-promo__copy">
            <span className="genai-english-promo__eyebrow">New</span>
            <h3>GenAI Software Builder</h3>
            <p>
              Turn ideas into working apps faster with AI-assisted building, unlimited Workspaces, and a dedicated Virtual Server
              environment ready for real delivery.
            </p>
            <div className="genai-english-promo__meta">
              <span><i className="las la-check-circle"></i> AI-powered app building</span>
              <span><i className="las la-check-circle"></i> Cloud Workspaces</span>
              <span><i className="las la-check-circle"></i> Dedicated Cloud VM per plan</span>
            </div>
            <a href="/genai" className="genai-english-promo__cta">
              Explore GenAI
              <i className="las la-arrow-right"></i>
            </a>
          </div>

          <div className="genai-english-promo__visual" aria-hidden="true">
            <div className="genai-english-promo__panel">
              <div className="genai-english-promo__panel-top">
                <div className="genai-english-promo__dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="genai-english-promo__chip">Dedicated VM</span>
              </div>
              <div className="genai-english-promo__prompt">
                <strong>Prompt</strong>
                <p>Build a client portal with authentication, dashboard, orders, and admin tools.</p>
              </div>
              <div className="genai-english-promo__flow">
                <span>Describe</span>
                <span>Build with AI</span>
                <span>Preview</span>
                <span>Launch</span>
              </div>
            </div>
          </div>
        </motion.div>

        <Row className="align-items-center mb-5">
          <Col lg={6}>
            <motion.div
              className="cicd-image-wrapper"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="cicd-visualization-modern">
                <motion.div 
                  className="pipeline-hexagon"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.1 }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.1)" }}
                >
                  <div className="hexagon-content">
                    <i className="las la-code"></i>
                    <span>Code</span>
                  </div>
                  <div className="connection-line"></div>
                </motion.div>

                <motion.div 
                  className="pipeline-hexagon"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.1)" }}
                >
                  <div className="hexagon-content">
                    <i className="las la-vial"></i>
                    <span>Test</span>
                  </div>
                  <div className="connection-line"></div>
                </motion.div>

                <motion.div 
                  className="pipeline-hexagon"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.3 }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.1)" }}
                >
                  <div className="hexagon-content">
                    <i className="las la-box"></i>
                    <span>Build</span>
                  </div>
                  <div className="connection-line"></div>
                </motion.div>

                <motion.div 
                  className="pipeline-hexagon"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.4 }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.1)" }}
                >
                  <div className="hexagon-content">
                    <i className="las la-rocket"></i>
                    <span>Deploy</span>
                  </div>
                  <div className="connection-line"></div>
                </motion.div>

                <motion.div 
                  className="pipeline-hexagon"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.1)" }}
                >
                  <div className="hexagon-content">
                    <i className="las la-chart-line"></i>
                    <span>Monitor</span>
                  </div>
                </motion.div>

                <motion.div 
                  className="pipeline-progress"
                  initial={{ width: "0%" }}
                  whileInView={{ width: "100%" }}
                  transition={{ duration: 1.5, delay: 0.6 }}
                />
              </div>

              <motion.div 
                className="tech-badges-modern"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
              >
                <motion.div 
                  className="tech-badge-modern"
                  whileHover={{ scale: 1.1, rotate: 10 }}
                >
                  <i className="lab la-docker"></i>
                  <span>Docker</span>
                </motion.div>
                <motion.div 
                  className="tech-badge-modern"
                  whileHover={{ scale: 1.1, rotate: -10 }}
                >
                  <i className="lab la-aws"></i>
                  <span>AWS</span>
                </motion.div>
                <motion.div 
                  className="tech-badge-modern"
                  whileHover={{ scale: 1.1, rotate: 10 }}
                >
                  <i className="lab la-github"></i>
                  <span>GitHub</span>
                </motion.div>
              </motion.div>
            </motion.div>
          </Col>
          <Col lg={6}>
            <motion.div
              className="feature-highlights"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="highlight-title">Boosted Productivity</h3>
              <ul className="highlight-list">
                <li><i className="las la-check-circle"></i> Automated CI/CD Pipeline</li>
                <li><i className="las la-check-circle"></i> Containerized Applications</li>
                <li><i className="las la-check-circle"></i> Cloud-Native Architecture</li>
                <li><i className="las la-check-circle"></i> Scalable Infrastructure</li>
              </ul>
            </motion.div>
          </Col>
        </Row>

        {/* Landscape Section */}
        <motion.div
          className="landscape-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Container>
            <Row className="justify-content-center mb-5">
              <Col lg={10} className="text-center">
                <motion.div
                  className="landscape-header"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <h2 className="landscape-title">
                    Our expertise is built on direct in-house work within organizations and hands-on involvement in multiple projects.
                  </h2>
                </motion.div>
              </Col>
            </Row>

            {/* Category 1: Direct In-House Work */}
            <Row className="mb-4">
              <Col lg={12}>
                <motion.div
                  className="category-section"
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                >
                  <h3 className="category-title">Organizations and Projects We Were Involved In</h3>
                  <div className="organizations-grid">
                    {[
                      { name: "The Israel National Cyber Directorate (INCD)", link: "https://www.gov.il/en/departments/israel_national_cyber_directorate/govil-landing-page" },
                      { name: "Vishay Intertechnology", link: "https://www.vishay.com" },
                      { name: "OneForIsrael.org", link: "https://www.oneforisrael.org/" },
                      { name: "Israel College of the bible", link: "https://biblecollege.co.il/" },
                      { name: "Bible.New", link: "https://bible.new/" },
                      { name: "The Cyber Education Center (CEC)", link: "https://cyber.org.il/about-us-eng/" }
                    ].map((org, index) => (
                      <motion.div
                        key={`cat1-${index}`}
                        className="organization-card"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
                        whileHover={{ scale: 1.03, y: -5 }}
                      >
                        {org.link ? (
                          <a href={org.link} target="_blank" rel="noopener noreferrer" className="organization-link">
                            <i className="las la-external-link-alt"></i>
                            <span>{org.name}</span>
                          </a>
                        ) : (
                          <div className="organization-name">
                            <i className="las la-external-link-alt"></i>
                            <span>{org.name}</span>
                          </div>
                        )}
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              </Col>
            </Row>

            {/* Category 2: Organizations Powered by Our Cloud Hosting */}
            <Row className="mb-4">
              <Col lg={12}>
                <motion.div
                  className="category-section"
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                >
                  <h3 className="category-title">Organizations Powered by Our Cloud Hosting and Development Services</h3>
                  <div className="organizations-grid">
                    {[
                      { name: "Negev Doors", link: "https://negev-dlatot.co.il/" },
                      { name: "Electric Tools", link: "https://electric-tools.co.il/" },
                      { name: "Abitbul Lawyers", link: "https://abitbul-law.org/" },
                      { name: "PhotoMark", link: "https://photomark.co.il/" },
                      { name: "Modern Woman", link: "https://modern-woman.co.il/" },
                      { name: "The land's marble", link: "https://shaiesh-haaretz.co.il/" },
                    ].map((org, index) => (
                      <motion.div
                        key={`cat2-${index}`}
                        className="organization-card"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.6 + index * 0.1 }}
                        whileHover={{ scale: 1.03, y: -5 }}
                      >
                        {org.link ? (
                          <a href={org.link} target="_blank" rel="noopener noreferrer" className="organization-link">
                            <i className="las la-external-link-alt"></i>
                            <span>{org.name}</span>
                          </a>
                        ) : (
                          <div className="organization-name">
                            <i className="las la-external-link-alt"></i>
                            <span>{org.name}</span>
                          </div>
                        )}
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              </Col>
            </Row>

            {/* Educational Foundation - Compact Version */}
            <Row className="mt-3">
              <Col lg={12} className="text-center">
                <motion.div
                  className="educational-foundation-compact"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.7 }}
                >
                  <a href="https://tcb.ac.il/en/" target="_blank" rel="noopener noreferrer" className="educational-link-compact">
                    <i className="las la-external-link-alt"></i>
                    <span>
                      Our lead engineers are P.A. Software Engineers from the Technological College of Be'er Sheva, with over sixty years of technological excellence.
                    </span>
                  </a>
                </motion.div>
              </Col>
            </Row>
          </Container>
        </motion.div>

        <motion.div 
          className="features-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.1
              }
            }
          }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="modern-feature-card"
              onClick={() => navigate(feature.path)}
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: {
                    duration: 0.5,
                    delay: feature.delay
                  }
                }
              }}
              whileHover={{ 
                scale: 1.02,
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)"
              }}
              transition={{ duration: 0.2 }}
            >
              <div className="feature-icon" style={{ background: feature.background }}>
                <i className={feature.icon}></i>
              </div>
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
              <div className="feature-arrow">
                <i className="las la-arrow-right"></i>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <Row className="justify-content-center mt-5">
          <Col lg={10} className="text-center">
            <motion.div
              className="platform-cta"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="platform-badge">
                <i className="las la-rocket"></i>
                <span>Instant Project Setup</span>
              </div>
              <h2 className="platform-title">
                Start Building Your Next Project with
                <span style={{ color: "#2563eb" }}> epicfinal</span>
              </h2>
              <p className="platform-description">
                Launch your project in minutes with our automated platform. 
                Get instant access to our full suite of development tools and expert support.
              </p>
              <div className="platform-features">
                <div className="platform-feature">
                  <i className="las la-bolt"></i>
                  <span>Instant Setup</span>
                </div>
                <div className="platform-feature">
                  <i className="las la-code-branch"></i>
                  <span>CI/CD Ready</span>
                </div>
                <div className="platform-feature">
                  <i className="las la-shield-alt"></i>
                  <span>Secure by Default</span>
                </div>
                <div className="platform-feature">
                  <i className="las la-clock"></i>
                  <span>Support & Consulting</span>
                </div>
              </div>
              <motion.div className="platform-actions">
                <div className="platform-action-group">
                  <span className="platform-action-label">Want to turn your idea into a working product?</span>
                  <motion.a 
                    href="genai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="platform-btn primary"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Launch Your GenAI Project
                    <i className="las la-rocket"></i>
                  </motion.a>
                </div>
                <div className="platform-action-group">
                  <span className="platform-action-label">Need an engineer on demand?</span>
                  <motion.a 
                    href="pricing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="platform-btn secondary"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <span>DevSecOps ONE Subscription</span>
                    <i className="las la-play-circle"></i>
                  </motion.a>
                </div>
              </motion.div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default FeatureL2;
